document.addEventListener("click", function (e) {
  const title = e.target.closest(".product__content .accordion__title");
  if (!title) return;

  const accordion = title.closest(".product__content .accordion");
  if (!accordion) return;

  const body = accordion.querySelector(".accordion__body");
  if (!body) return;

  const isOpen = accordion.classList.contains("is-open");

  // 1️⃣ Cerrar todos
  document.querySelectorAll(".product__content .accordion").forEach(acc => {
    acc.classList.remove("is-open");
  });

  document.querySelectorAll(".product__content .accordion__body").forEach(b => {
    b.style.height = "0px";
  });

  // 2️⃣ Si el clicado estaba abierto, lo dejamos cerrado
  if (isOpen) return;

  // 3️⃣ Si estaba cerrado, abrirlo
  setTimeout(() => {
    accordion.classList.add("is-open");
    body.style.height = "auto";
  }, 100);

  // 4️⃣ Scroll suave
  setTimeout(() => {
    const y = accordion.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, 400);
});
